import React from "react";
import handleState from "./handleState";

const CircleWithTextViewGradingPage = ({ text, state }) => {
    return (
        <>
            <div className="square-with-text-view">
                <div className={`bubble ${handleState(state)}`} style={{ cursor: "auto" }}/>
                { text }
            </div>
        </>
    );
}

export default CircleWithTextViewGradingPage;